import ResetPwd from './ResetPwd';

export default ResetPwd;
